"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMultilineTextInput = exports.StyledSingleLineTextInput = void 0;
var polished_1 = require("polished");
var styled_components_1 = __importStar(require("styled-components"));
var TextSize_1 = require("../Shared/TextSize");
var createCommonTextInputStyles = function (size, hasError, hasBorder) { return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  visibility: visible;\n\n  padding: 12px 16px;\n  background-color: ", ";\n  border: none;\n  color: ", ";\n  font-size: ", ";\n  width: 100%;\n\n  ::placeholder {\n    color: ", ";\n  }\n\n  &:focus {\n    border-color: ", ";\n  }\n\n  // :focus-visible fires on click of text inputs but not on click of other input types.\n  // as such, the :focus-visible styling is different here to other inputs.\n  &:focus-visible {\n    border-color: ", ";\n    outline: none;\n  }\n\n  &:disabled {\n    background-color: ", ";\n    color: ", ";\n    cursor: not-allowed;\n  }\n\n  ", "\n\n  ", "\n"], ["\n  visibility: visible;\n\n  padding: 12px 16px;\n  background-color: ", ";\n  border: none;\n  color: ", ";\n  font-size: ", ";\n  width: 100%;\n\n  ::placeholder {\n    color: ", ";\n  }\n\n  &:focus {\n    border-color: ", ";\n  }\n\n  // :focus-visible fires on click of text inputs but not on click of other input types.\n  // as such, the :focus-visible styling is different here to other inputs.\n  &:focus-visible {\n    border-color: ", ";\n    outline: none;\n  }\n\n  &:disabled {\n    background-color: ", ";\n    color: ", ";\n    cursor: not-allowed;\n  }\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.background.input;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.text.primary;
}, (0, polished_1.rem)(TextSize_1.TextSize[size]), function (_a) {
    var theme = _a.theme;
    return theme.colors.text.placeholder;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.border.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.border.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.background.disabled;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.text.disabled;
}, hasBorder && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-radius: 16px;\n    border: ", ";\n  "], ["\n    border-radius: 16px;\n    border: ", ";\n  "])), function (_a) {
    var theme = _a.theme;
    return "1px solid ".concat(theme.colors.border.secondary);
}), hasError && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border: ", ";\n  "], ["\n    border: ", ";\n  "])), function (_a) {
    var theme = _a.theme;
    return "1px solid ".concat(theme.colors.border.error);
})); };
exports.StyledSingleLineTextInput = styled_components_1.default.input.attrs({
    type: 'text',
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  line-height: 1;\n"], ["\n  ", "\n  line-height: 1;\n"])), function (_a) {
    var $size = _a.$size, hasError = _a.hasError, hasBorder = _a.hasBorder;
    return createCommonTextInputStyles($size, hasError, hasBorder);
});
exports.StyledMultilineTextInput = styled_components_1.default.textarea.attrs({
    type: 'text',
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n  resize: none;\n  line-height: 150%;\n"], ["\n  ", "\n  resize: none;\n  line-height: 150%;\n"])), function (_a) {
    var $size = _a.$size, hasError = _a.hasError, hasBorder = _a.hasBorder;
    return createCommonTextInputStyles($size, hasError, hasBorder);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
